import { getShipperBusiness, type Shipment, type ShipperBusiness } from '../../domain/Shipment'

export function useShipmentChargesPermissions(shipment: Shipment | undefined) {
  const accessorialsEnabledByShipperBusiness: Record<ShipperBusiness, boolean> = {
    BROKERAGE: false,
    MTC: true,
    SAAS: true,
    FBM: false,
  }

  const isEnabledByBusiness = accessorialsEnabledByShipperBusiness[getShipperBusiness(shipment)]

  return { isShipmentChargesEnabled: isEnabledByBusiness }
}
